/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/signUpUser.config.json";
import axios from "axios";

export interface SignUpUserProps {
  email: string;
  password: string;
  passwordResetToken: string;
  apiURL: string;
  headers: any;
}

export interface ISignUpUserMethods extends IPluginMethodMap {
  getSignUpUser(args: any): Promise<any>;
}

export class SignUpUserService implements IAgentPlugin {
  readonly methods: ISignUpUserMethods;

  constructor() {
    this.methods = {
      getSignUpUser: this.getSignUpUser.bind(this),
    };
  }

  async getSignUpUser(args: SignUpUserProps) {
    try {
      const res = await axios.post(
        `${args?.apiURL}${config?.signUpEP}`,
        {
          email: args?.email,
          token: args?.passwordResetToken,
          password: args?.password,
        },
        {
          headers: {
            ...args?.headers,
          },
        }
      );
      if (res?.data) {
        console.log(`image data`, res);
        return res?.data;
      }
      // return true;
    } catch (err: any) {
      console.log(`sign up error`, err?.response?.data);
      return err?.response?.data;
    }
  }
}
